import { SearchesService } from '../services'

export default (id) => {
  return SearchesService.getBusqHistOC(id)
    .then((response) => {
      if (!response) {
        const error = new Error('HTTP_ERROR')
        error.response = response
        return Promise.reject(error)
      }

      return response.data
    })
    .catch((error) => Promise.reject(error))
}
